<template>
<div style="background-color: white; ">
  
  <section class="hero">
      <b-tabs v-model="activeTab">
          <b-tab-item >
               <div class="hero-body">
                  <h1>
                    Congratulations!
                  </h1>
                  <p class="subtitle">
                    You are a champion Cookie Finder! 
                  </p>
                <b-button   @click="activeTab=1" >Want to unlock the final surprise?</b-button>
                </div>
          </b-tab-item>

          <b-tab-item > 
                <div class="hero-body">
                  <h2>
                    For a fun surprise..
                  </h2>
                  <p class="subtitle">
                   Juliette Gordon Low sold her diamonds to fund the Girl Scouts?<br/>
                 
                    <b-button @click="makeGuess(0)" >True</b-button>
                    <b-button @click="makeGuess(1)" >False</b-button>
                  </p>
       
                <div v-if="guess == 0" class="answer-wrong">Not quite - try again.</div>
                <div v-if="guess == correctAnswer" class="answer-correct"><h3>That’s right! It was pearls, not diamonds.</h3></div>

                </div>
            </b-tab-item>

             <b-tab-item >
               <div class="hero-body ">
                    <h2>Nice work!</h2>
                    <p>Now pick your favorite color</p>
                        <br/>
                         <b-button @click="SetColor('red')" type="is-danger" >Red</b-button>
                         <b-button @click="SetColor('orange')" type="is-warning" style="background-color:orange" >Orange</b-button>
                         <b-button @click="SetColor('yellow')" type="is-warning" >Yellow</b-button>
                         <b-button @click="SetColor('green')" type="is-success" >Green</b-button>
                         <b-button @click="SetColor('blue')" type="is-info" >Blue</b-button>
                         <b-button @click="SetColor('violet')" type="is-primary" >Violet</b-button>
                          <b-button @click="goParty()" focused>Strobe Light</b-button>
                     
               </div>
             </b-tab-item >
              <b-tab-item >
                    <div class="hero-body ">
                    <h2>Thank you so much for playing!</h2>
                    
                        #cookiefinder <br/>
                        #girlscoutcentral
               </div>
              </b-tab-item>
    </b-tabs>
    
  </section>

  </div>
   
</template>

<script>
import { api } from "./api.js"

export default {
  name: "Question",
  props: {
  },
  data() {
    return {
      activeTab: 0,
      correctAnswer: 1,
      guess: -1,
      finalTimeout: null,
      party: false
    };
  },
  computed:{
  
  },
  mounted(){
   
  },
  methods:{
    goParty(){
      
      this.party = !this.party
      let state = this.party  ? "on" : "off"
      let data =  `arg=flash-${state}`
      api.go.post('finalToggle', data)
    },
    SetColor(color){
      var data =  `arg=${color}`
      api.go.post('finalToggle', data)
      const self = this;

      if(this.finalTimeout == null) {
          this.finalTimeout = setTimeout(() => { 
            self.SetColor("")
            //self.$parent.close()
            console.log("close")
            self.finalTimeout = null
            self.activeTab = 3
        }, 20000);
      }
    },
    makeGuess(guess){
      this.$ga.event({
        eventCategory: 'Questions',
        eventAction: 'Guess',
        eventLabel: this.name,
        eventValue: guess
      })

      this.guess = guess;
      const self = this;

      if(guess == this.correctAnswer)
      {
        setTimeout(() => { self.activeTab = 2 }, 3000);

        //close modal

      }


    }
  },

};
</script>
